import React from "react";
import ProfileCard from "pages/Profile/components/common/ProfileCard";

interface Props {
  isEdit?: boolean;
}

const TalentSpecs = ({ isEdit }: Props) => {
  const specs = [
    { label: "Your location", value: "New York, NY" },
    { label: "Work permits", value: "USA, UK, Canada" },
    { label: "Gender", value: "Female" },
    { label: "Disability", value: "None declared" },
    { label: "Actual age", value: "28 years" },
    { label: "Playing age", value: "25-35 years" },
    { label: "Height", value: "5'8\"" },
    { label: "Nationalities", value: "American" },
    { label: "Ethnicity or Heritage", value: "White", block: true },
    { label: "Membership", value: "SAG-AFTRA, AEA" },
    { label: "Appearance", value: "Athletic build, professional", block: true },
    {
      label: "Complexion shades",
      value: "Fair to Light: NC15-NC25",
      block: true,
    },
    { label: "Hair colour", value: "Blonde" },
    { label: "Hair length", value: "Medium" },
    { label: "Eye colour", value: "Blue" },
    { label: "Voice quality", value: "Clear, resonant" },
    { label: "Voice character", value: "Warm, engaging" },
    { label: "Vocal range", value: "Alto (G3 to E5)" },
    { label: "Chest", value: '34"' },
    { label: "Waist", value: '26"' },
    { label: "Hips", value: '36"' },
    { label: "Weight", value: "9 st 2 lb" },
    { label: "Collar", value: '13"' },
    { label: "Shoe size", value: "8" },
  ];

  return (
    <ProfileCard className="tex-s grid grid-cols-1 gap-1.5" isEdit={isEdit}>
      {specs.map((item, index) => (
        <div key={index} className="flex flex-wrap gap-1.5">
          <span className="font-semibold dark:text-white/90">
            {item.label}:
          </span>
          <span className="dark:text-white/70">{item.value}</span>
        </div>
      ))}
    </ProfileCard>
  );
};

export default TalentSpecs;
